import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MainComponent } from '@modules/main/main.component';
import { BlankComponent } from '@pages/blank/blank.component';
import { LoginComponent } from '@modules/login/login.component';
import { ProfileComponent } from '@pages/profile/profile.component';
import { RegisterComponent } from '@modules/register/register.component';
import { DashboardComponent } from '@pages/dashboard/dashboard.component';
import { ForgotPasswordComponent } from '@modules/forgot-password/forgot-password.component';
import { RecoverPasswordComponent } from '@modules/recover-password/recover-password.component';
import { MainMenuComponent } from '@pages/main-menu/main-menu.component';
import { SubMenuComponent } from '@pages/main-menu/sub-menu/sub-menu.component';

import { AuthGuard } from '@guards/auth.guard';
import { NonAuthGuard } from '@guards/non-auth.guard';

const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    canActivate: [AuthGuard],
    children: [
      // { path: 'profile', component: ProfileComponent },
      // { path: 'blank', component: BlankComponent },
      // { path: 'sub-menu-1', component: SubMenuComponent },
      // { path: 'sub-menu-2', component: BlankComponent },
      { path: 'home', component: DashboardComponent },
      {
        path: 'catalogos',
        loadChildren: () =>
          import('./modules/catalogos/catalogos.module').then(m => m.CatalogosModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'administrador',
        loadChildren: () =>
          import('./modules/administrador/administrador.module').then(m => m.AdministradorModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'analisis',
        loadChildren: () =>
          import('./modules/analisis/analisis.module').then(m => m.AnalisisModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'consultas',
        loadChildren: () =>
          import('./modules/consultas/consultas.module').then(m => m.ConsultasModule),
        canActivate: [AuthGuard]
      },
      { path: '', redirectTo: 'home', pathMatch: 'full' }
    ]
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [NonAuthGuard]
  },
  {
    path: 'register',
    component: RegisterComponent,
    canActivate: [NonAuthGuard]
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    canActivate: [NonAuthGuard]
  },
  {
    path: 'recover-password',
    component: RecoverPasswordComponent,
    canActivate: [NonAuthGuard]
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
